import React, { FC } from "react";
import { MessageSquare } from "@yleisradio/yds-icons-react";
import styled from "styled-components";

import { useEmbedParametersContext } from "../../contexts/EmbedParametersContext";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import { fontFamily } from "../../styles/global";
import { controlsTextColor, focusColor } from "../../styles/variables";

const ChatButtonStyled = styled.button`
  background: transparent;
  border-radius: 16px;
  border: 2px solid ${controlsTextColor};
  color: ${controlsTextColor};
  cursor: pointer;
  font-weight: 700;
  height: 32px;
  padding: 0 12px;
  pointer-events: all;
  white-space: nowrap;
  ${fontFamily}

  svg {
    position: relative;
    top: 2px;
    margin-left: 5px;
  }

  &:focus-visible {
    outline: 1px solid ${focusColor} !important;
  }
`;

export const ChatButton: FC = () => {
  const { useStoreState } = usePlayerStore();
  const externalEvents = useStoreState.externalEvents();
  const { language } = useEmbedParametersContext();

  return (
    <ChatButtonStyled
      onClick={() => externalEvents?.dispatch("chatButtonClicked")}>
      {i18n("avaa_chat", { language })}
      <MessageSquare width={16} height={16} />
    </ChatButtonStyled>
  );
};
